export default __webpack_public_path__ + "static/media/workVibe.c62fff83.png";